// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1Wejv","right":"styles_right__26TIR"};